import { render } from "./shopCategory.vue?vue&type=template&id=20f540cc&ts=true"
import script from "./shopCategory.vue?vue&type=script&lang=ts"
export * from "./shopCategory.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__